/* eslint-disable prettier/prettier */
import { lazy, Suspense, useState } from 'react';
import { BrowserRouter, Routes, Route, HashRouter, Navigate, Outlet } from 'react-router-dom';
import { G, ROUTES } from 'enums';
import { DynamicModal, DynamicDrawer, Header, SideBar } from 'components';

import * as S from './App.styles';
import { useLocation } from 'react-router';

const MarketTrends = lazy(() => import('./views/MarketTrends'));
const CompetitorAnalysis = lazy(() => import('./views/CompetitorAnalysis'));
const PriceCalculator = lazy(() => import('./views/PriceCalculator'));
const MyStock = lazy(() => import('./views/MyStock'));
const Login = lazy(() => import('./views/Login'));
const Home = lazy(() => import('./views/Home'));

const SideBarAndNavbar = ({ children }: { children: JSX.Element }): JSX.Element => {
  const [sidebarIsOpen, setSidebarIsOpen] = useState(true);
  const { pathname } = useLocation();
  return (
    <>
      <DynamicModal />
      <DynamicDrawer />
      <Header sidebarIsOpen={sidebarIsOpen} onToggleSidebar={(): void => setSidebarIsOpen((prev) => !prev)} />
      <S.AppContent>
        {pathname.length > 1 && (
          <div className="app__siderbar">
            <SideBar sidebarIsOpen={sidebarIsOpen} />
          </div>
        )}
        <S.AppView>{children}</S.AppView>
      </S.AppContent>
    </>
  );
};

const ProtectedRoute = (): JSX.Element => {
  if (!localStorage.getItem(G.token)) return <Navigate to={ROUTES.login} replace />;
  return <Outlet />;
};

export const Router = (): JSX.Element => {
  const STAGING = process?.env?.REACT_APP_STAGING;

  const TheRouter = (STAGING ? HashRouter : BrowserRouter) as typeof BrowserRouter;

  return (
    <Suspense fallback={null}>
      <TheRouter>
        <Routes>
          <Route path={ROUTES.login} element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route
              path={ROUTES.home}
              element={
                <SideBarAndNavbar>
                  <Home />
                </SideBarAndNavbar>
              }
            />
            <Route
              path={ROUTES.marketTrends}
              element={
                <SideBarAndNavbar>
                  <MarketTrends />
                </SideBarAndNavbar>
              }
            />
            <Route
              path={ROUTES.competitorAnalysis}
              element={
                <SideBarAndNavbar>
                  <CompetitorAnalysis />
                </SideBarAndNavbar>
              }
            />
            <Route
              path={ROUTES.priceCalculator}
              element={
                <SideBarAndNavbar>
                  <PriceCalculator />
                </SideBarAndNavbar>
              }
            />
            <Route
              path={ROUTES.myStock}
              element={
                <SideBarAndNavbar>
                  <MyStock />
                </SideBarAndNavbar>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </TheRouter>
    </Suspense>
  );
};
